import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import Collapse from "react-bootstrap/Collapse";
import { IMAGES } from "../../../constant/theme";
import {
  getTenantUser,
  getUserByTenantId,
  mapUserWithTenant,
} from "../../../../services/TenantsService";
import { Button } from "react-bootstrap";

const AboutTenant = () => {
  const location = useLocation();

  const user = location.state?.user || null;
  const [open2, setOpen2] = useState(true);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [userTenant, setUserTenant] = useState(null);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const pageSize = 20;

  async function fetchUserTenant() {
    const res = await getUserByTenantId(user?.id, 0, 20);
    if (res) {
      console.log("User Tenants:", res);
      setUserTenant(res.content);
    }
  }

  useEffect(() => {
    if (user?.id) {
      fetchUserTenant();
    }
  }, [user]);

  // const loadTenants = async (pageToLoad = 0) => {
  //   if (isLoading || !hasMore) return;
  //   try {
  //     setIsLoading(true);
  //     const data = await getTenantUser(pageToLoad, pageSize);
  //     if (data) {
  //       const existingTenantIds =
  //         (userTenant.length > 0 && userTenant?.map((t) => t?.tenant?.id)) ||
  //         [];
  //       const filterTenantData = data?.content?.filter((t) => {
  //         return !existingTenantIds.includes(t?.id);
  //       });
  //       console.log("filterTenantData sk", filterTenantData);
  //       const newOptions = filterTenantData?.map((user) => ({
  //         label: user?.name,
  //         value: user?.id,
  //       }));

  //       setTenantOptions((prev) => [...prev, ...newOptions]);

  //       // If backend sends info about last page:
  //       if (data.last === true || data.content.length < pageSize) {
  //         setHasMore(false);
  //       } else {
  //         setPage(pageToLoad + 1);
  //       }
  //     }
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const loadTenants = async (pageToLoad = 0) => {
    if (isLoading || !hasMore) return;

    try {
      setIsLoading(true);

      const data = await getTenantUser(pageToLoad, pageSize);

      if (data) {
        console.log("Tenant Data:", data);
        const existingTenantIds = userTenant?.map((t) => t?.id) || [];

        const filterTenantData = data?.content?.filter(
          (t) => !existingTenantIds.includes(t?.id),
        );

        const newOptions = filterTenantData?.map((tenant) => ({
          label: `${tenant?.name} - ${tenant?.email}`,
          value: tenant?.id,
        }));

        setTenantOptions((prev) => [...prev, ...newOptions]);

        if (data.last === true || data.content.length < pageSize) {
          setHasMore(false);
        } else {
          setPage((prev) => prev + 1);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTenants();
  }, []);

  async function handleAddTenant() {
    var payload = {
      tenantId: user?.id,
      userId: selectedTenant?.value,
    };
    const data = await mapUserWithTenant(payload);
    if (data) {
      fetchUserTenant();
      setSelectedTenant(null);
    } else {
      console.error("Failed to add tenant");
    }
  }

  return (
    <>
      <div className="page-titles d-flex justify-content-between align-items-center">
        <h4 className="mb-0">About Academy</h4>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item ">
            <Link to="/super-admin/all-tenants">Academies</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link
              onClick={(e) => e.preventDefault()}
              to="#"
              style={{
                pointerEvents: "none",
                color: "inherit",
                color: "#6F77F8",
              }}
            >
              About Academy
            </Link>
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-xl-3 col-lg-4">
          <div className="clearfix">
            <div className="card card-bx profile-card author-profile mb-3">
              <div className="card-body">
                <div className="p-5">
                  <div className="author-profile">
                    <div className="author-media">
                      <img src={IMAGES.tab1} alt="" />
                      <div
                        className="upload-link"
                        title=""
                        data-toggle="tooltip"
                        data-placement="right"
                        data-original-title="update"
                      >
                        <input type="file" className="update-flie" />
                        <i className="fa fa-camera"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-lg-8">
          <div className="card profile-card card-bx ">
            <div className="card-header">
              <h6 className="card-title">Academy Details</h6>
            </div>
            <form className="profile-form">
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.name || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Email address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.email || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Phone</label>
                    <input
                      type="number"
                      className="form-control"
                      value={user?.phone || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Landline</label>
                    <input
                      type="number"
                      className="form-control"
                      value={user?.landLine || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Contact Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.contactName || ""}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mb-3">
                    <label className="form-label">Status Comment</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user?.statusComment || ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              {/* <div className="card-footer align-items-center d-flex">
                <Link to={"#"} className="btn-link float-end ms-auto">
                  Reset your password?
                </Link>
              </div> */}
            </form>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="d-flex justify-content-end gap-2">
            <div className="mb-3 col-3">
              <Select
                value={selectedTenant}
                onChange={setSelectedTenant}
                options={tenantOptions}
                placeholder="Select user"
                onMenuScrollToBottom={() => {
                  if (hasMore && !isLoading) {
                    loadTenants(page); // load next page
                  }
                }}
                isLoading={isLoading}
              />
            </div>
            <div className="mb-3 ">
              <Button
                className="btn btn-primary btn-m"
                disabled={!selectedTenant}
                onClick={handleAddTenant}
              >
                Add User
              </Button>
            </div>
          </div>

          <div className="filter cm-content-box box-primary">
            <div className={`content-title`} onClick={() => setOpen2(!open2)}>
              <div className="cpa">
                <i className="fa-solid fa-file-lines me-2" />
                Users List
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body py-3">
                  <div className="table-responsive order-list-table">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table className="table table-responsive-lg  table-condensed flip-content">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Landline</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {userTenant?.map((item, ind) => (
                            <tr key={ind}>
                              <td>{ind + 1}</td>
                              <td>{item?.name}</td>
                              <td>{item?.email}</td>
                              <td>{item?.phone}</td>
                              <td>{item?.landLine}</td>
                              <td>
                                {item?.defaultTenant?.admin ? "Admin" : "User"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};
export default AboutTenant;
